import React from "react";
import { QueryFilter } from "@ant-design/pro-components";
import type { FormInstance } from "antd";

import type { FilterConfig, FilterData } from "../../dataTypes";
import {
  getSelectFilter,
  getRadioFilter,
  getDatePickerFilter,
  getDateRangePickerFilter,
  getSearchAreaFilter,
} from "../../dataTypes";

type SearchFormProps = {
  form: FormInstance;
  filters?: FilterData[];
  onSearch: (values: any) => Promise<void> | void;
  onReset?: () => void;
  searchConfig?: FilterConfig["submitRenderer"];
};

export function SearchForm({
  form,
  filters = [],
  onSearch,
  onReset,
  searchConfig,
}: SearchFormProps) {
  const renderFilter = (filter: FilterData): React.ReactNode => {
    switch (filter.filterType) {
      case "SELECT":
        return getSelectFilter(filter);
      case "RADIO":
        return getRadioFilter(filter);
      case "DATE":
        return getDatePickerFilter(filter);
      case "DATE_RANGE":
        return getDateRangePickerFilter(filter);
      default:
        return null;
    }
  };

  const onFinish = async (): Promise<boolean | void> => {
    const values = form.getFieldsValue();
    console.log("onFinish", values);
    return onSearch(values);
  };

  return (
    <QueryFilter
      form={form}
      onFinish={onFinish}
      onReset={onReset}
      labelWidth="auto"
      defaultCollapsed={false}
      span={8}
      submitter={{
        resetButtonProps: {
          children: "Reset",
        },
        submitButtonProps: {
          children: "Search",
          type: "primary",
        },
      }}
    >
      {searchConfig && (
        <React.Fragment key="search-field">{getSearchAreaFilter(searchConfig)}</React.Fragment>
      )}
      {filters.map((filter) => (
        <React.Fragment key={filter.fieldName}>{renderFilter(filter)}</React.Fragment>
      ))}
    </QueryFilter>
  );
}
